import { createContext, useContext, useEffect, useState, useCallback } from "react";
import client, { setToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = authed
  const [mode, setMode] = useState(null); // null = unknown/checking, "DRY_RUN" | "LIVE" | "UNKNOWN"
  const [wp, setWp] = useState({ connected: false });

  const refreshMe = useCallback(async () => {
    try {
      const { data } = await client.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  const refreshMode = useCallback(async () => {
    try {
      const { data } = await client.get("/mode");
      setMode(data.mode);
    } catch { setMode("UNKNOWN"); }
  }, []);

  const refreshWp = useCallback(async () => {
    try {
      const { data } = await client.get("/wp/status");
      setWp(data);
    } catch {}
  }, []);

  useEffect(() => {
    (async () => {
      const u = await refreshMe();
      if (u) {
        refreshMode();
        refreshWp();
      }
    })();
  }, [refreshMe, refreshMode, refreshWp]);

  const login = async (email, password) => {
    const { data } = await client.post("/auth/login", { email, password });
    setToken(data.token);
    const u = await refreshMe();
    await refreshMode();
    await refreshWp();
    return u;
  };

  const logout = async () => {
    try { await client.post("/auth/logout"); } catch {}
    setToken(null);
    setUser(false);
    setWp({ connected: false });
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, mode, setMode, refreshMode, wp, refreshWp }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
